import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token from localStorage
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 globally
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (!window.location.pathname.includes('/login')) {
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);

// ─── Auth ─────────────────────────────────────────────────────────────────────
export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  logout: () => api.post('/auth/logout'),
  getMe: () => api.get('/auth/me'),
  refresh: () => api.post('/auth/refresh'),
};

// ─── Projects ─────────────────────────────────────────────────────────────────
export const projectAPI = {
  getAll: (params) => api.get('/projects', { params }),
  getOne: (id) => api.get(`/projects/${id}`),
  create: (data) => api.post('/projects', data),
  update: (id, data) => api.put(`/projects/${id}`, data),
  remove: (id) => api.delete(`/projects/${id}`),
  getMembers: (id) => api.get(`/projects/${id}/members`),
  addMember: (id, data) => api.post(`/projects/${id}/members`, data),
  removeMember: (id, userId) => api.delete(`/projects/${id}/members/${userId}`),
};

// ─── Daily Status ─────────────────────────────────────────────────────────────
export const statusAPI = {
  getAll: (projectId) => api.get(`/projects/${projectId}/status`),
  add: (projectId, data) => api.post(`/projects/${projectId}/status`, data),
  update: (projectId, statusId, data) => api.put(`/projects/${projectId}/status/${statusId}`, data),
  delete: (projectId, statusId) => api.delete(`/projects/${projectId}/status/${statusId}`),
};

// ─── Defects ──────────────────────────────────────────────────────────────────
export const defectAPI = {
  getAll: (projectId, params) => api.get(`/projects/${projectId}/defects`, { params }),
  create: (projectId, data) => api.post(`/projects/${projectId}/defects`, data),
  update: (projectId, defectId, data) => api.put(`/projects/${projectId}/defects/${defectId}`, data),
  getComments: (projectId, defectId) => api.get(`/projects/${projectId}/defects/${defectId}/comments`),
  addComment: (projectId, defectId, data) => api.post(`/projects/${projectId}/defects/${defectId}/comments`, data),
};

// ─── Dashboard & Reports ──────────────────────────────────────────────────────
export const dashboardAPI = {
  get: () => api.get('/dashboard'),
  defectReport: () => api.get('/reports/defects'),
  teamProductivity: (params) => api.get('/reports/team-productivity', { params }),
};

// ─── Users ────────────────────────────────────────────────────────────────────
export const userAPI = {
  getAll: () => api.get('/users'),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  unblock: (id) => api.put(`/users/${id}/unblock`),
};

export default api;

export const categoryAPI = {
  getAll: () => api.get('/categories'),
  create: (data) => api.post('/categories', data),
  update: (id, data) => api.put(`/categories/${id}`, data),
  remove: (id) => api.delete(`/categories/${id}`),
};